'use strict';

var _regeneratorRuntime = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var CID = require('cids');

var util = require('./util');
/**
 * Resolves a path within a PB block.
 *
 * If the path resolves half-way to a link, then the `remainderPath` is the part
 * after the link that can be used for further resolving
 *
 * Returns the value or a link and the partial missing path. This way the
 * IPLD Resolver can fetch the link and continue to resolve.
 *
 * @param {Uint8Array} binaryBlob - Binary representation of a PB block
 * @param {string} [path='/'] - Path that should be resolved
 */


exports.resolve = function (binaryBlob) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var node = util.deserialize(binaryBlob);
  var parts = path.split('/').filter(Boolean);

  while (parts.length) {
    var key = parts.shift(); // @ts-ignore

    if (node[key] === undefined) {
      // There might be a matching named link
      var _iterator = _createForOfIteratorHelper(node.Links),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var link = _step.value;

          if (link.Name === key) {
            return {
              value: link.Hash,
              remainderPath: parts.join('/')
            };
          }
        } // There wasn't even a matching named link

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      throw new Error("Object has no property '".concat(key, "'"));
    } // @ts-ignore


    node = node[key];

    if (CID.isCID(node)) {
      return {
        value: node,
        remainderPath: parts.join('/')
      };
    }
  }

  return {
    value: node,
    remainderPath: ''
  };
};
/**
 * Return all available paths of a block.
 *
 * @generator
 * @param {Uint8Array} binaryBlob - Binary representation of a PB block
 * @yields {string} - A single path
 */


exports.tree = /*#__PURE__*/_regeneratorRuntime.mark(function _callee(binaryBlob) {
  var node, ii;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          node = util.deserialize(binaryBlob); // There is always a `Data` and `Links` property

          _context.next = 3;
          return 'Data';

        case 3:
          _context.next = 5;
          return 'Links';

        case 5:
          ii = 0;

        case 6:
          if (!(ii < node.Links.length)) {
            _context.next = 18;
            break;
          }

          _context.next = 9;
          return "Links/".concat(ii);

        case 9:
          _context.next = 11;
          return "Links/".concat(ii, "/Name");

        case 11:
          _context.next = 13;
          return "Links/".concat(ii, "/Tsize");

        case 13:
          _context.next = 15;
          return "Links/".concat(ii, "/Hash");

        case 15:
          ii++;
          _context.next = 6;
          break;

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
});